export default "__VITE_PUBLIC_ASSET__b9426482__"